"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _noAuthApiClient = _interopRequireDefault(require("hub-http/clients/noAuthApiClient"));

var _default =
/*#__PURE__*/
function () {
  function _default() {
    (0, _classCallCheck2.default)(this, _default);
  }

  (0, _createClass2.default)(_default, [{
    key: "makeGetRequest",
    value: function makeGetRequest(url, options) {
      return _noAuthApiClient.default.getWithResponse(url, options);
    }
  }, {
    key: "makePostRequest",
    value: function makePostRequest(url, options) {
      return _noAuthApiClient.default.post(url, options);
    }
  }]);
  return _default;
}();

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/api/API.js
// module id = 99
// module chunks = 0